import { useState } from "react";

const ButtonItem = ({ command, value, styleHandler, Icon, nodes, node }) => {
  const [isActive, setisActive] = useState(nodes.includes(node) ? true : false);

  const onClick = () => {
    setisActive(!isActive);
    if (value) {
      styleHandler(command, value);
    } else {
      styleHandler(command);
    }
  };
  return (
    <button
      onClick={onClick}
      className={`mx-2 text-xs ${isActive ? "text-sky-500" : "text-white"}`}
    >
      <Icon />
    </button>
  );
};

export default ButtonItem;
